import { render } from "./homeBotSep.vue?vue&type=template&id=7db67c46&scoped=true"
const script = {}

import "./homeBotSep.vue?vue&type=style&index=0&id=7db67c46&lang=css&scoped=true"

import exportComponent from "C:\\blissappp\\theblissholidays\\bliss-site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db67c46"]])

export default __exports__